/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_System_Sync_WaitingInputs */

const bn_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অপেক্ষা করছে`)
};

const de_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WARTEN`)
};

const el_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΑΝΑΜΟΝΗ`)
};

const en_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAITING`)
};

const es_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESPERA`)
};

const fr_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EN ATTENTE`)
};

const hi_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंतज़ार में`)
};

const hu_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VÁRAKOZÁS`)
};

const id_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MENUNGGU`)
};

const it_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IN ATTESA`)
};

const ja_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待っている`)
};

const ko_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대기 중`)
};

const nl_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WACHTEN`)
};

const pl_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CZEKANIE`)
};

const pt_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESPERANDO`)
};

const ru_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОЖИДАЮЩИЙ`)
};

const sv_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VÄNTAN`)
};

const tr_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BEKLEMEK`)
};

const uk_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОЧІКУВАННЯ`)
};

const vi_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CHỜ`)
};

const zh_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待`)
};

const zh_hant_cipher_system_sync_waiting = /** @type {(inputs: Cipher_System_Sync_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待`)
};

/**
* | output |
* | --- |
* | "WAITING" |
*
* @param {Cipher_System_Sync_WaitingInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_system_sync_waiting = /** @type {((inputs?: Cipher_System_Sync_WaitingInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_System_Sync_WaitingInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_system_sync_waiting(inputs)
	if (locale === "de") return de_cipher_system_sync_waiting(inputs)
	if (locale === "el") return el_cipher_system_sync_waiting(inputs)
	if (locale === "en") return en_cipher_system_sync_waiting(inputs)
	if (locale === "es") return es_cipher_system_sync_waiting(inputs)
	if (locale === "fr") return fr_cipher_system_sync_waiting(inputs)
	if (locale === "hi") return hi_cipher_system_sync_waiting(inputs)
	if (locale === "hu") return hu_cipher_system_sync_waiting(inputs)
	if (locale === "id") return id_cipher_system_sync_waiting(inputs)
	if (locale === "it") return it_cipher_system_sync_waiting(inputs)
	if (locale === "ja") return ja_cipher_system_sync_waiting(inputs)
	if (locale === "ko") return ko_cipher_system_sync_waiting(inputs)
	if (locale === "nl") return nl_cipher_system_sync_waiting(inputs)
	if (locale === "pl") return pl_cipher_system_sync_waiting(inputs)
	if (locale === "pt") return pt_cipher_system_sync_waiting(inputs)
	if (locale === "ru") return ru_cipher_system_sync_waiting(inputs)
	if (locale === "sv") return sv_cipher_system_sync_waiting(inputs)
	if (locale === "tr") return tr_cipher_system_sync_waiting(inputs)
	if (locale === "uk") return uk_cipher_system_sync_waiting(inputs)
	if (locale === "vi") return vi_cipher_system_sync_waiting(inputs)
	if (locale === "zh") return zh_cipher_system_sync_waiting(inputs)
	return zh_hant_cipher_system_sync_waiting(inputs)
});